<template>
  <div class="w-full mt-4">
    <LeaderboardTable
      :entries="entries"
      :loading="loading"
      :current-user-id="currentUserId"
      period-label="of all time"
      empty-text="No rankings yet."/>
  </div>
</template>
<script setup>

import {computed, onMounted} from "vue";
import {useScores} from "../composables/useScores.js";
import {useLevels} from "../composables/useLevels.js";
import {useFormat} from "../composables/useFormat.js";
import LeaderboardTable from "./LeaderboardTable.vue";

const {rankings, getRankings, loading} = useScores();
const {calculateCurrentLevel} = useLevels();
const {formatCompact} = useFormat();

const currentUserId = localStorage.getItem('userId') || '';

onMounted(async () => {
  await getRankings();
})

const entries = computed(() => rankings.value.map(r => ({
  id: r.id,
  name: r.name,
  verified: r.verified,
  valueDisplay: `${formatCompact(r.xp)} XP`,
  chip: `Lvl ${calculateCurrentLevel(r.xp)}`
})));

</script>


<style scoped>

</style>
